module["exports"] = [
  "Pvt Ltd",
  "Limited",
  "Ltd",
  "and Sons",
  "Corp",
  "Group",
  "Brothers"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/en_IND/company/suffix.js
// module id = 672
// module chunks = 0